<template>
  <div class="sms-captcha">
    <input
      ref="input"
      type="text"
      :placeholder="placeholder"
      v-model="data"
      autocomplete="off"
      :disabled="disabled"
      :maxlength="maxlength"
      @blur="blur"
      @change="keyup"
    />
    <a
      class="btn"
      :class="smsBtnDisabled?`disabled`:``"
      @click="handleClick">{{ dataSmsBtnText }}</a>
  </div>
</template>

<script>
import Schema from 'async-validator';

export default {
  name: 'AuthFormSmsCaptcha',
  props: {
    maxlength: Number,
    placeholder: {
      type: String,
    },
    rule: {
      type: [Object, Array],
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    smsBtnText: {
      type: String,
      default: '获取验证码',
    },
    value: [String, Number],
  },
  data() {
    return {
      data: '',
      validator: null,
      message: '',
      smsBtnDisabled: false,
      dataSmsBtnText: '',
    };
  },
  watch: {
    value(n, o) {
      const newVal = JSON.stringify(n);
      const oldVal = JSON.stringify(o);
      if (newVal === oldVal) return;
      this.data = n;
    },
  },

  mounted() {
    this.dataSmsBtnText = this.smsBtnText;
  },

  methods: {
    check() {
      return new Promise((resolve) => {
        this.validate().then(() => {
          this.$emit('validator', true);
          resolve(true);
        }, (msg) => {
          this.$emit('validator', msg);
          resolve(false);
        });
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        new Schema({
          value: this.rule,
        }).validate({value: this.data}, (err) => {
          if (err) {
            reject(err[0].message);
          } else {
            resolve();
          }
        });
      });
    },
    keyup() {
      this.$emit('input', this.data);
    },
    blur() {
      this.validate().then(() => {
        this.$emit('validator', true);
      }, (msg) => {
        this.$emit('validator', msg);
      });
    },
    handleClick() {
      if (this.smsBtnDisabled) return;
      this.$emit('sms-query', (countdown) => {
        this.smsBtnDisabled = true;
        let sec = countdown || 60;
        const time = setInterval(() => {
          if (sec < 1) {
            clearInterval(time);
            this.smsBtnDisabled = false;
            this.dataSmsBtnText = '获取验证码';
          } else {
            sec--;
            this.dataSmsBtnText = '等待' + sec + '(s)';
          }
        }, 1000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  background: #f7f7f7;
  color: #ccc;
  border-color: #ccc;
}
  input {
    color: rgba(0,0,0,.45);
  }
</style>
